// removed by extract-text-webpack-plugin
module.exports = {"product-variants":"src-modules-accommodation-AccommodationSchedulerView-__AccommodationSchedulerForm__product-variants--1OYHk","field-section":"src-modules-accommodation-AccommodationSchedulerView-__AccommodationSchedulerForm__field-section--3vFOw","loading-message":"src-modules-accommodation-AccommodationSchedulerView-__AccommodationSchedulerForm__loading-message--2oXwe","total-stock-left-field-container":"src-modules-accommodation-AccommodationSchedulerView-__AccommodationSchedulerForm__total-stock-left-field-container--2VZu9"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/accommodation/AccommodationSchedulerView/AccommodationSchedulerForm.less
// module id = 1871
// module chunks = 0